import { styled, keyframes } from '@mui/material/styles';
import { LinearProgress, Box } from '@mui/material';

export const LinearProgressStyled = styled(LinearProgress, {
  name: 'LinearProgressStyled',
})(() => ({
  marginTop: '-6px',
  height: '2px',
  width: 'calc(100% - 6px)',
  marginLeft: '3px',
}));

export const SaveButtonContainerStyled = styled(Box, {
  name: 'SaveButtonContainerStyled',
})(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const savedPulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
`;
